// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--max: rgb(255, 255, 255);
	--mid: #80bff0;
	--min: var(--blue);
}

.LoadingPreview_container__k-EDB {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	display: flex;
	gap: 20px;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;
	background: #052E26;
	z-index: 10000;
}

.LoadingPreview_loaderCon__9G5l3 {
	width: 100px;
	height: 100px;
	flex-shrink: 0;
	overflow: hidden;
	/* box-shadow: inset 0 0 15px #052E26; */
}

.LoadingPreview_cubesMask__SalJ4 {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	box-shadow: inset 0 0 10px 10px #052E26;
}

.LoadingPreview_cubes__119ZG {
	/* z-index: 1; */
	gap: 15px;
	position: absolute;
	bottom: 0;
	animation-name: LoadingPreview_slide__2Nl3e;
	animation-duration: 2.5s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
}

.LoadingPreview_cube__5Thjh {
	position: relative;
	width: 25px;
	height: 25px;
	/* transform: scale(0.3, 0.3); */
}

.LoadingPreview_topFace__b5Y8z {
	position: absolute;
	height: 10px;
	width: 25px;
	right: 0;
	top: -5px;
	border: 1px solid #fff;
	transform: skew(45deg);
}

.LoadingPreview_leftFace__TUI8F {
	position: absolute;
	width: 10px;
	height: 25px;
	left: -5px;
	bottom: 0;
	background: #ffffff80;
	border: 1px solid #fff;
	transform: skew(0, 45deg);
}

.LoadingPreview_frontFace__09g7k {
	position: absolute;
	width: 25px;
	height: 25px;
	right: -5px;
	bottom: -5px;
	border: 1px solid #fff;
}

@keyframes LoadingPreview_slide__2Nl3e {
	0% {
		bottom: 0;
	}

	100% {
		bottom: -80px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoadingPreview.module.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CACX,aAAa;CACb,SAAS;CACT,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,cAAc;CACd,gBAAgB;CAChB,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,uCAAuC;AACxC;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,SAAS;CACT,2CAAqB;CACrB,wBAAwB;CACxB,mCAAmC;CACnC,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,QAAQ;CACR,SAAS;CACT,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,UAAU;CACV,SAAS;CACT,qBAAqB;CACrB,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC;EACC,SAAS;CACV;;CAEA;EACC,aAAa;CACd;AACD","sourcesContent":[":root {\n\t--max: rgb(255, 255, 255);\n\t--mid: #80bff0;\n\t--min: var(--blue);\n}\n\n.container {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tgap: 20px;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tbackground: #052E26;\n\tz-index: 10000;\n}\n\n.loaderCon {\n\twidth: 100px;\n\theight: 100px;\n\tflex-shrink: 0;\n\toverflow: hidden;\n\t/* box-shadow: inset 0 0 15px #052E26; */\n}\n\n.cubesMask {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbox-shadow: inset 0 0 10px 10px #052E26;\n}\n\n.cubes {\n\t/* z-index: 1; */\n\tgap: 15px;\n\tposition: absolute;\n\tbottom: 0;\n\tanimation-name: slide;\n\tanimation-duration: 2.5s;\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: linear;\n}\n\n.cube {\n\tposition: relative;\n\twidth: 25px;\n\theight: 25px;\n\t/* transform: scale(0.3, 0.3); */\n}\n\n.topFace {\n\tposition: absolute;\n\theight: 10px;\n\twidth: 25px;\n\tright: 0;\n\ttop: -5px;\n\tborder: 1px solid #fff;\n\ttransform: skew(45deg);\n}\n\n.leftFace {\n\tposition: absolute;\n\twidth: 10px;\n\theight: 25px;\n\tleft: -5px;\n\tbottom: 0;\n\tbackground: #ffffff80;\n\tborder: 1px solid #fff;\n\ttransform: skew(0, 45deg);\n}\n\n.frontFace {\n\tposition: absolute;\n\twidth: 25px;\n\theight: 25px;\n\tright: -5px;\n\tbottom: -5px;\n\tborder: 1px solid #fff;\n}\n\n@keyframes slide {\n\t0% {\n\t\tbottom: 0;\n\t}\n\n\t100% {\n\t\tbottom: -80px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoadingPreview_container__k-EDB`,
	"loaderCon": `LoadingPreview_loaderCon__9G5l3`,
	"cubesMask": `LoadingPreview_cubesMask__SalJ4`,
	"cubes": `LoadingPreview_cubes__119ZG`,
	"slide": `LoadingPreview_slide__2Nl3e`,
	"cube": `LoadingPreview_cube__5Thjh`,
	"topFace": `LoadingPreview_topFace__b5Y8z`,
	"leftFace": `LoadingPreview_leftFace__TUI8F`,
	"frontFace": `LoadingPreview_frontFace__09g7k`
};
export default ___CSS_LOADER_EXPORT___;
